import React from 'react';
import { Link } from 'react-router-dom';

const ServiceInnerDetails = ({ serviceId }) => {
    // Configuração de conteúdo por serviço
    const content = {
        recrutamento: {
            titulo: "Maximizando a Assertividade nas Admissões",
            texto: "Erros na contratação geram prejuízos financeiros severos e travam a produtividade operacional. Nosso processo completo de atração, triagem e seleção identifica profissionais perfeitamente alinhados à cultura e aos objetivos de crescimento do seu negócio.",
            lista: ["Triagem rigorosa conduzida com critérios técnicos e comportamentais refinados.", "Processos ágeis mapeados para reduzir o tempo de contratação.", "Seleção cirúrgica focada em profissionais de alta aderência cultural."],
            imagem: "assets/img/servicos/2/1.png" // Imagem exclusiva do serviço 1
        },
        hunting: {
            titulo: "Acesso Exclusivo aos Talentos de Alta Performance",
            texto: "Nossa metodologia de Hunting executa uma busca ativa, confidencial e extremamente focada para mapear e atrair os perfis C-Level e especialistas de difícil acesso que a sua operação exige.",
            lista: ["Mapeamento cirúrgico de posições técnicas, comerciais e executivas.", "Abordagem premium com foco em profissionais passivos no mercado.", "Sigilo absoluto e máxima precisão técnica."],
            imagem: "assets/img/servicos/2/2.png" // Imagem exclusiva do serviço 2
        },
        equipes: {
            titulo: "Escalabilidade e Montagem Rápida de Times",
            texto: "Desenvolvemos o planejamento logístico de atração para recrutar, selecionar e estruturar equipes operacionais e corporativas completas no menor tempo possível.",
            lista: ["Desenvolvimento integrado de equipes para novas filiais.", "Montagem célere mantendo o rigor técnico.", "Suporte robusto para picos sazonais."],
            imagem: "assets/img/servicos/2/3.png" // Imagem exclusiva do serviço 3
        },
        rpo: {
            titulo: "Terceirização Inteligente de Recrutamento",
            texto: "Com o RPO, realizamos a terceirização parcial ou integral de todas as etapas do seu recrutamento, posicionando um braço de elite acoplado à sua empresa.",
            lista: ["Redução imediata de custos operacionais e burocráticos.", "Escalabilidade sob medida para o volume de vagas.", "Indicadores rigorosos de performance e controle."],
            imagem: "assets/img/servicos/2/3.png" // Imagem exclusiva do serviço 4
        },
        consultoria: {
            titulo: "Otimização Organizacional e Cultura",
            texto: "Desenvolvemos soluções completas voltadas à organização de processos seletivos, mapeamento de perfil profissional e gestão de metas para otimizar o desempenho do seu quadro funcional.",
            lista: ["Mapeamento comportamental para diminuir taxas de turnover.", "Estruturação de metodologias de avaliação de performance.", "Alinhamento às boas práticas da LGPD."],
            imagem: "assets/img/servicos/2/4.png" // Imagem exclusiva do serviço 5
        }
    };

    const data = content[serviceId] || content.recrutamento;

    return (
        <section className="space">
            <div className="container">
                <div className="row gx-30">
                    <div className="col-xxl-8 col-lg-7">
                        <div className="page-thumb">
                            {/* AQUI ESTÁ A MÁGICA: A imagem muda conforme a página! E o alt ajuda no SEO */}
                            <img src={data.imagem} alt={data.titulo} />
                        </div>
                        <ul className="service-details-list">
                            <li className="single-service-list">
                                <span className="title">Categoria </span>
                                <h6 className="content">Gestão de RH Estratégico</h6>
                            </li>
                            <li className="single-service-list">
                                <span className="title">Unidade </span>
                                <h6 className="content">Grupo Rocvel</h6>
                            </li>
                        </ul>
                        
                        <h3 className="page-title mt-40 mb-20">{data.titulo}</h3>
                        <p>{data.texto}</p>
                        
                        <div className="checklist style6 mt-40 mb-60">
                            <ul>
                                {data.lista.map((item, index) => (
                                    <li key={index}>
                                        <i className="fas fa-check-circle" /> {item}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                    
                    {/* Sidebar fixa com links para outras páginas */}
                    <div className="col-xxl-4 col-lg-5">
                        <aside className="sidebar-area">
                            <div className="widget widget_categories widget_service-categories">
                                <ul>
                                    <li><Link to="/recrutamento-e-selecao">Recrutamento e Seleção</Link></li>
                                    <li><Link to="/hunting-especializado">Hunting Executivo</Link></li>
                                    <li><Link to="/estruturacao-de-equipes">Estruturação de Equipes</Link></li>
                                    <li><Link to="/rpo-recrutamento">RPO (Terceirização)</Link></li>
                                    <li><Link to="/consultoria-rh">Consultoria em RH</Link></li>
                                </ul>
                            </div>
                        </aside>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ServiceInnerDetails;